import { startLoader,stopLoader } from "../slice/loaderSlice";
import { stopToast, toastaction } from "../slice/toastSlice";
import { store } from "../store";


export const loader = {
    start: () => store.dispatch(startLoader()),
    stop: () => store.dispatch(stopLoader())
}

export const toast = {
    success: (msg) => store.dispatch(toastaction({ type: "success", msg })),
    error: (msg) => store.dispatch(toastaction({ type: "error", msg })),
    warning: (msg) => store.dispatch(toastaction({ type: "warning", msg })),
    info: (msg) => store.dispatch(toastaction({ type: "info", msg })),
    stop: () => store.dispatch(stopToast())
}